import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import { reducer as notifications } from 'react-notification-system-redux';

import authentication from './authentication';
import contacts from './contacts';
import contactreassigns from './contactreassigns';
import asset from './asset';
import defaulttext from './defaulttext';
import download from './download';
import exports from './exports';
import plasmascreens from './plasmascreens';
import property from './property';
import shared from './shared';
import stations from './stations';
import toletboards from './toletboards';
import contactrequests from './contactrequests';

export default combineReducers({
    authentication,
    contacts,
    contactreassigns,
    asset,
    defaulttext,
    download,
    exports,
    form,
    notifications,
    plasmascreens,
    property,
    shared,
    stations,
    toletboards,
    contactrequests,
});



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js